import { atom } from "recoil";
import { ITransactionInfo } from "types/transaction.d";

export const transactionState = atom({
  key: "transactionState",
  default: null as ITransactionInfo | null,
});
